"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelServiceName = exports.ChannelIDs = exports.EChannelAttributeKey = exports.ChannelConnectionOffersState = exports.ChannelConnectionStatus = exports.ChannelType = void 0;
var ChannelType;
(function (ChannelType) {
    ChannelType["Marketplace"] = "MARKETPLACE";
    ChannelType["Ecommerce"] = "ECOMMERCE";
    ChannelType["Storefront"] = "STOREFRONT";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
var ChannelConnectionStatus;
(function (ChannelConnectionStatus) {
    ChannelConnectionStatus["Deleted"] = "DELETED";
    ChannelConnectionStatus["Invalid"] = "INVALID";
    ChannelConnectionStatus["New"] = "NEW";
    ChannelConnectionStatus["TokenExpired"] = "TOKEN_EXPIRED";
    ChannelConnectionStatus["Valid"] = "VALID";
})(ChannelConnectionStatus || (exports.ChannelConnectionStatus = ChannelConnectionStatus = {}));
var ChannelConnectionOffersState;
(function (ChannelConnectionOffersState) {
    ChannelConnectionOffersState["Archiving"] = "ARCHIVING";
    ChannelConnectionOffersState["Archived"] = "ARCHIVED";
    ChannelConnectionOffersState["Creating"] = "CREATING";
    ChannelConnectionOffersState["Created"] = "CREATED";
    ChannelConnectionOffersState["Pending"] = "PENDING";
})(ChannelConnectionOffersState || (exports.ChannelConnectionOffersState = ChannelConnectionOffersState = {}));
var EChannelAttributeKey;
(function (EChannelAttributeKey) {
    EChannelAttributeKey["VariantOfferTitle"] = "variant.offer.title";
})(EChannelAttributeKey || (exports.EChannelAttributeKey = EChannelAttributeKey = {}));
var ChannelIDs;
(function (ChannelIDs) {
    ChannelIDs["AMZUS"] = "AMZUS";
    ChannelIDs["AMZBR"] = "AMZBR";
    ChannelIDs["AMZES"] = "AMZES";
    ChannelIDs["AMZMX"] = "AMZMX";
    ChannelIDs["AMZIN"] = "AMZIN";
    ChannelIDs["AMZUK"] = "AMZUK";
    ChannelIDs["MLB"] = "MLB";
    ChannelIDs["SHOPIFY"] = "SHOPIFY";
    ChannelIDs["STOREFRONT"] = "STOREFRONT";
    ChannelIDs["SHOPEE"] = "SHOPEE";
})(ChannelIDs || (exports.ChannelIDs = ChannelIDs = {}));
var ChannelServiceName;
(function (ChannelServiceName) {
    ChannelServiceName["ChannelML"] = "channel-ml";
    ChannelServiceName["ChannelAMZ"] = "channel-amz";
    ChannelServiceName["ChannelShopee"] = "channel-shopee";
    ChannelServiceName["ChannelShopify"] = "channel-shopify";
    ChannelServiceName["ChannelStoreFront"] = "channel-storefront";
})(ChannelServiceName || (exports.ChannelServiceName = ChannelServiceName = {}));
//# sourceMappingURL=channel.js.map